import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 45,
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 37,
  },
  downloadButton: {
    marginTop: 22,
  },
  datePickerContainer: {
    flex: 0.3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  filters: {
    flex: 0.7,
    paddingLeft: 30,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  searchWrapper: {
    paddingRight: theme.spacing(20),
    maxWidth: theme.spacing(151),
  },
  denomination: {
    color: theme.palette.common.black,
    fontWeight: 500,
  },
  tableItemDefaultStyle: {
    fontSize: 16,
    color: theme.palette.grey['400'],
    fontWeight: 300,
  },
}));
